export default __webpack_public_path__ + "static/media/social_copylink.e4185a15.svg";